import React from 'react';
import { Spinner } from 'reactstrap';

function FullScreenSpinner() {
  return (
    <span style={{ height: "80vh" }} className="d-flex justify-content-center align-items-center"><Spinner /><span className="ml-2">Loading</span></span>
  );
}

export default FullScreenSpinner;